import { render, staticRenderFns } from "./image-input.vue?vue&type=template&id=2499fbe7&scoped=true"
import script from "./image-input.vue?vue&type=script&lang=js"
export * from "./image-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499fbe7",
  null
  
)

export default component.exports